import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FeaturesService } from '../../core/services/features.service';

@Injectable()
export class FeatureGuard  {
  private featuresService = inject(FeaturesService);


  canActivate(route: ActivatedRouteSnapshot): boolean {
    const feature = route.data['feature'];
    return feature && this.featuresService.get()[feature] === true;
  }
}
